import { CUSTOMIZETABLE } from 'constants/apis';
import log from 'loglevel';
import Fetch from 'helpers/fetch';
import { buildUrl } from 'helpers/misc';

// We use Object keys for viewcodes but some tables are having specialcase
// where viewcode is different than object key
const viewCodeSpecialCases = {
  ordersSearch: 'orders',
  submittedTab: 'jobs',
  receivedJobs: 'jobs',
  prepaidAll:'prepaidrequest',
};


const handleColumnSave = (keys, viewCode, setAppState) => {
  const DataList = keys.map(item => ({ DataField: item }));

  const parameters = {
    viewCode,
    applicationCode: 'CP',
  };

  Fetch.Post(buildUrl(CUSTOMIZETABLE, parameters), { DataList })
    .catch(err => log.error(err));

  const isSpecialCase = Object.keys(viewCodeSpecialCases)
    .includes(viewCode);

  setAppState(prevState => ({
    [viewCode]: {
      ...prevState[viewCode],
      keys,
      shouldLoad: !prevState.handleDataManually,
    },
  }), isSpecialCase ? () => setAppState(prevState => ({
    [viewCodeSpecialCases[viewCode]]: {
      ...prevState[viewCodeSpecialCases[viewCode]],
      shouldLoad: true,
    },
  })) : null);
};

export { handleColumnSave, viewCodeSpecialCases };



// WEBPACK FOOTER //
// ./src/helpers/column-save.js